import React from "react";
import { IMerchandiseDetails } from "repoV2/features/Listing/Listing.interfaces";
import CheckoutFormContextProvider from "./CheckoutFormContextProvider";
import CheckoutThemeContextProvider from "./CheckoutThemeContextProvider";
import CheckoutBasicDetailsContextProvider from "./CheckoutBasicDetailsContextProvider";
import { ICheckoutListingDetails } from "../utils/apis/ListingDetailsApi/IListingDetailsApi.interface";
import { ICheckoutCreatorDetails } from "../utils/apis/CreatorDetailsApi/ICreatorDetailsApi.interface";
import CheckoutPriceDetailsContextProvider from "./CheckoutPriceDetailsContextProvider";
import ExpressInterestContextProvider from "./CheckoutExpressInterestContextProider";

export interface IOverallCheckoutContextProvider {
    listingDetails: ICheckoutListingDetails;
    creatorDetails: ICheckoutCreatorDetails;
    merchandiseDetails: IMerchandiseDetails;
    listingSlug: string;
    hostName: string;
    showExpressInterestForm: boolean;
    isRenewSubscription: boolean;
    thankyouUuid: string;
    communityUuid: string;
    dynamicLinkUuid: string;
    isCheckoutPagePreviewMode: boolean;
    children?: JSX.Element | JSX.Element[];
}

// here data segregation into different contexts happen
const OverallCheckoutContextProvider: React.FC<IOverallCheckoutContextProvider> =
    ({
        children,
        listingDetails,
        creatorDetails,
        merchandiseDetails,
        listingSlug,
        hostName,
        showExpressInterestForm,
        isRenewSubscription,
        thankyouUuid,
        communityUuid,
        dynamicLinkUuid,
        isCheckoutPagePreviewMode,
    }) => {
        const withCheckoutThemeContext = (
            <CheckoutThemeContextProvider
                creatorDetails={creatorDetails}
                dynamicLinkUuid={dynamicLinkUuid}
            >
                {children}
            </CheckoutThemeContextProvider>
        );
        const withCheckoutBasicDetailsContext = (
            <CheckoutBasicDetailsContextProvider
                listingDetails={listingDetails}
                creatorDetails={creatorDetails}
                merchandiseDetails={merchandiseDetails}
                listingSlug={listingSlug}
                hostName={hostName}
                showExpressInterestForm={showExpressInterestForm}
                isRenewSubscription={isRenewSubscription}
                thankyouUuid={thankyouUuid}
                communityUuid={communityUuid}
                dynamicLinkUuid={dynamicLinkUuid}
                isCheckoutPagePreviewMode={isCheckoutPagePreviewMode}
            >
                {withCheckoutThemeContext}
            </CheckoutBasicDetailsContextProvider>
        );

        const withExpressInterestContext = (
            <ExpressInterestContextProvider
                creatorDetails={creatorDetails}
                listingDetails={listingDetails}
            >
                {withCheckoutBasicDetailsContext}
            </ExpressInterestContextProvider>
        );

        const withCheckoutPriceDetailsContext = (
            <CheckoutPriceDetailsContextProvider
                initialData={{ creatorDetails }}
            >
                {withExpressInterestContext}
            </CheckoutPriceDetailsContextProvider>
        );

        const withCheckoutFormContext = (
            <CheckoutFormContextProvider creatorDetails={creatorDetails}>
                {withCheckoutPriceDetailsContext}
            </CheckoutFormContextProvider>
        );

        return withCheckoutFormContext;
    };

export default OverallCheckoutContextProvider;
